// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__P5KBw","approved":"Status_approved__2flfT","rejected":"Status_rejected__c6-2n","expired":"Status_expired__3axC3","label":"Status_label__1M2uu"};